(ns app.front.view.group.admin.bonds.accounts
  "Route for bond admin view and main accounts tab"
  (:require [app.front.ui :as ui]
            [app.front.ui.sortable-table :as sortable-table]
            [app.front.util :as futil]
            [app.front.view.bond.common :as view-common]
            [app.front.view.bond.util :as bond-util]
            [app.front.view.group.admin.bonds.config :as bond-config]
            [app.front.view.group.admin.bonds.groups :as bond-groups]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.subs :as gas]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.util.util :as util]))

(defn accounts-table []
  (let [lang          (<sub [:language])
        tr            (<sub [::gas/group-tr])
        group-id      (<sub [::gas/group-id])
        items         (<sub [::bond-groups/group-bonds group-id])
        owner-or-bond (fn [bond] (or (:bond/owner bond) bond))
        cols          [[(tr [:bond/status]) #(tr [(:domain/state %)])]
                       [(tr [:user/email]) (comp view-common/format-owner-email owner-or-bond)]
                       [(tr [:bond/owner]) #(bond-util/format-bond-owner lang (owner-or-bond %) tr)]
                       [(tr [:bond/amount]) view-common/format-bond-amount]
                       [(tr [:bond/expires-on]) (partial view-common/format-bond-expiration lang)]]]
    [:div.m-4 (sortable-table/table
                {:id            "accounts-table"
                 :tr            tr
                 :cols          cols
                 :configurable? true
                 :expanded-func (fn [bond] [view-common/bond-view bond tr]) ;; or view-common/bond-details
                 :on-expand     (fn [bond-id _]
                                  (>evt [::view-common/set-current-bond bond-id])
                                  (>evt [::view-common/sync-workspace-attachment-types])
                                  (>evt [::view-common/fetch-related-workspaces bond-id]))
                 :get-status    view-common/bond-status-colors
                 :get-focus?    (constantly false)
                 :id-func       :bond/id
                 :items         items})]))

(defn search-box []
  (let [tr (<sub [::gas/group-tr])]
    [:div.flex.mt-2.justify-end.m-4
     [:div.w-full.sm:w-1-2.lg:w-1-3
      [ui/search
       {:id                      "bond-filter"
        :label-text              (tr [:bond/search-label])
        :close-button-label-text (tr [:search/empty])
        :placeholder             (tr [:bond/search-placeholder])
        :value                   (<sub [::bond-groups/filter-text])
        :on-change               #(>evt [::bond-groups/set-filter-text (futil/tval %)])
        :clear-fn                #(>evt [::bond-groups/set-filter-text nil])
        :hide-label              true}]]]))

(defn new-bond-button []
  (let [tr       (<sub [::gas/group-tr])
        group-id (<sub [::gas/group-id])]
    [:div.flex.mt-2.justify-end.m-4
     [ui/button
      {:href (href/href :view/bond.new {} {:group group-id})}
      (tr [:bond/new-bond])]]))

(defn accounts-tab []
  [:section
   [new-bond-button]
   [:div.p-2 [search-box] [accounts-table]]])

(defn view [match]
  (let [tr (<sub [::gas/group-tr])]
    [acommon/admin-page-v2
     (util/mmap
       {:allowed-group-types #{:group.type/domain}
        :title               (tr [:view/group.admin.bonds])
        :tabs                [[:bond.config/accounts-management-subtitle accounts-tab]
                              [:bond.config/accounts-configuration-subtitle bond-config/bonds-configuration]]}
       match)]))

(def route
  {:name        :view/group.admin.bonds
   :view        view
   :own-layout? true
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [{{:keys [group-id]} :path}]
                                (>evt [::gas/fetch-authority-groups group-id])
                                (>evt [::bond-groups/fetch-group-bonds group-id])
                                (>evt [::bond-config/init group-id]))}]})
